import React from 'react'
import '../../../Styles/App/HomeMB2.css'

const SectionHomeWeb = () => {
  return (
  <>
      <section className="ContainerSection1MBN">
        <div className="contentSection1MBN">

        </div>
      </section>
    </>
  )
}

export default SectionHomeWeb